<template>
  <v-container class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs v-model="tab"
        flat color="primary" dark
        grow height="40"
        fixed-tabs>
        <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`">
          {{ tabitem + ' ('+ ticketList[tabitem].length +')' }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-if="lAction === 'view'" v-model="tab">
        <v-tab-item v-for="(tabitem, n) in tabitems" :key="n" :id="`tab-${n}`">
          <v-layout class="pa-2">
            <v-flex xs12>
              <v-card flat>
                <v-card-text v-if="ticketList[tabitem].length === 0" class="info--text text-xs-center">No Tickets!</v-card-text>
                <v-expansion-panel>
                  <v-expansion-panel-content :value = "i === 0"
                  v-for="(ticketItem, i) in ticketList[tabitem]" :key="i" @input="loadTicket(ticketItem)">
                  <div slot="header">
                    <v-layout row class="pb-4">
                      <v-flex xs12 class="caption">
                        <div class="pa-1 grey lighten-4 caption black--text" style="position:absolute; top:5px; left:0px">
                          {{ 'Ticket #' + ticketItem.ticket_no }}
                        </div>
                        <div v-if="ticketItem.ticket_status === 'New' || ticketItem.ticket_status === 'Reopened'" class="pa-1 red lighten-2" style="position:absolute; top:5px; right:0px">
                          {{ ticketItem.ticket_status }}
                        </div>
                        <div v-else-if="ticketItem.ticket_status === 'Assigned'" class="pa-1 blue lighten-2" style="position:absolute; top:5px; right:0px">
                          {{ ticketItem.ticket_status }}
                        </div>
                        <div v-else-if="ticketItem.ticket_status === 'In Progress'" class="pa-1 yellow black--text" style="position:absolute; top:5px; right:0px">
                          {{ ticketItem.ticket_status }}
                        </div>
                        <div v-else-if="ticketItem.ticket_status === 'Resolved'" class="pa-1 success" style="position:absolute; top:5px; right:0px">
                          {{ ticketItem.ticket_status }}
                        </div>
                        <div v-else class="pa-1 error" style="position:absolute; top:5px; right:0px">
                          {{ ticketItem.ticket_status }}
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs9 sm9 md11 :class="$vuetify.breakpoint.sm?'ml-2':''">
                        <div class="subheading">
                          {{ ticketItem.ticket_title }}
                        </div>
                        <div class="caption grey--text mt-2">
                          <span class="mr-2">{{ handy.formatDateTime(ticketItem.ticket_dt) }}</span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>

                  <v-card flat>
                    <v-card-text class="pt-2 pb-2">
                      <div class="pb-3">{{ ticketItem.ticket_desc }}</div>
                      <!-- Notes -->
                      <v-card  v-for="(det, d) in ticketItem.details" :key="d"class="grey lighten-4 mb-1">
                        <v-card-text class="pt-2 pr-2 pb-0 pl-2">
                          <div>
                            <span class="caption grey--text">{{ det.ticket_status }} by {{ det.updated_by_temp }} {{ det.ticket_status === 'Assigned' && det.assigned_to ? ' to ' + det.assigned_to : '' }} - {{ handy.formatDateTime(det.updated_dt) }}</span>
                            <div class="info--text">{{ det.notes }} </div>
                          </div>
                        </v-card-text>
                        <v-card-actions class="pt-0">
                          <v-spacer></v-spacer>
                          <v-btn v-if="det.user_id && tabitem !== 'all closed'" class="mt-0" icon :disabled="beingSaved" @click.native="deleteNotes(ticketItem, det, d)"><v-icon small>delete</v-icon></v-btn>
                        </v-card-actions>
                      </v-card>

                      <div v-if="ticketItem.ready_for_comment">
                        <div>
                          <span color="grey" style="float:right"><v-btn class="ma-0" icon small @click.stop="cancelComment(ticketItem)"><v-icon small>clear</v-icon></v-btn></span>
                          <v-text-field hide-details textarea
                          placeholder="Your comment" rows="2"
                          v-model="ticketItem.comment.notes"></v-text-field>
                        </div>
                        <div style="float:right">
                          <v-btn class="ma-0" flat color="accent" @click.stop="postComment(ticketItem)" :disabled="beingSaved">Comment</v-btn>
                        </div>
                      </div>
                      <!-- Edit, Delete and Reopened -->
                      <div v-if="!ticketItem.ready_for_comment">
                        <v-card>
                          <v-card-actions class="ma-0 pa-0">
                            <v-spacer></v-spacer>
                            <v-btn v-if="tabitem === 'all open'" icon class="pl-3 pr-3" @click.native="prepareComment(ticketItem)"><v-icon small>comment</v-icon></v-btn>
                            <v-btn v-if="tabitem === 'all open'" icon @click.native="prepareEdit(ticketItem)"><v-icon small>edit</v-icon></v-btn>
                            <v-btn v-if="tabitem === 'all open'" icon :disabled="beingSaved" @click.native="deleteItem(ticketItem)"><v-icon small>delete</v-icon></v-btn>
                            <v-btn v-if="tabitem === 'all closed'"  small flat @click.native="reopenTicket(ticketItem)" :disabled="beingSaved">Reopen</v-btn>
                          </v-card-actions>
                        </v-card>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-btn :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:65px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed
      color="accent"
      @click.native="prepareCreate()">
      <v-icon>add</v-icon>
    </v-btn>
  </v-tabs-items>
</v-flex>
</v-layout>

<!-- 2. create / edit  ticket-->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
        <v-card flat>
          <v-flex xs12 sm9 mx-auto>
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lAction) }} Ticket
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12 class="mt-2">
                    <v-text-field
                    ref='title' v-model="ticket.ticket_title"
                    label="Ticket title"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="100"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                  class="mt-2"
                  v-model="ticket.ticket_desc"
                  label="Ticket description"
                  :rules="[rules.required]"
                  hide-details
                  multi-line
                  rows="4"
                  maxlength="1000"
                  >
                </v-text-field>
              </v-flex>
              <v-flex xs8 sm9 class="mt-1 subheading">
                <span>Is it critical?</span>
              </v-flex>
              <v-flex xs4 sm3>
                <v-switch
                :label="ticket.is_critical?'Yes':'No'"
                v-model="ticket.is_critical"
                hide-details
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn flat @click.stop="cancelChanges">Cancel</v-btn>
          <v-btn flat type="submit" color="accent" :disabled="beingSaved">Log</v-btn>
        </v-card-actions>
      </v-flex>
    </v-card>
  </v-form>
  <v-divider></v-divider>
</v-flex>
</v-layout>
</v-container>
<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="2000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      beingSaved: false,
      handy: handy,
      rules: handy.rules,
      tab: 'tab-0',
      ticketList: {},
      ticket: '',
      tabitems: ['all open', 'all closed'],
      ticketheadsm: [
        { text: 'Ticket No', value: 'ticket_no' },
        { text: 'Description', value: 'ticket_desc' },
        { text: 'Severity', value: 'severity' },
        { text: 'Status', value: 'ticket_status' }
      ],
      ticketHead: [
        { text: 'Ticket No', value: 'ticket_no' },
        { text: 'Description', value: 'ticket_desc' }
      ]
    }
  },
  created () {
    // initialize maps
    for (var i = 0; i < this.tabitems.length; i++) {
      this.ticketList[this.tabitems[i]] = []
    }
    // load ticket settings
    this.loadTicketList()
  },
  mounted () {
    this.lAction = 'view'
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyTicket () {
      var emptyTicket = {
        user_id: config.USER_ID,
        comp_by: config.CUST_NAME,
        comp_block_unit: config.UNITS[0].block_nm + ' ' + config.UNITS[0].unit_no,
        comp_phone: config.MOBILE_NO,
        comm_id: config.COMM_ID,
        severity: 'Normal',
        is_critical: false,
        ticket_desc: '',
        ticket_title: '',
        ticket_status: 'New',
        raised_mode: 'APP',
        ticket_on: 'Smartility'
      }
      return emptyTicket
    },
    prepareCreate () {
      this.ticket = this.getEmptyTicket()
      this.lAction = 'create'
    },
    prepareEdit (curTicket) {
      this.ticket = Object.assign({}, curTicket) // keep the original object safely before changes
      this.lAction = 'update'
    },
    loadTicketList () {
      var qry = {
        params: {
          user_id: config.USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getSmartilityTicketByUserId/', qry)
      .then(response => {
        this.ticketList['all open'] = response.data.filter(ticket => {
          return ticket.ticket_status === 'New' || ticket.ticket_status === 'Assigned' || ticket.ticket_status === 'Reopened' || ticket.ticket_status === 'In Progress' || ticket.ticket_status === 'On-hold'
        })
        this.ticketList['all closed'] = response.data.filter(ticket => {
          return ticket.ticket_status === 'Resolved' || ticket.ticket_status === 'Rejected'
        })
        if (this.ticketList['all open'].length) {
          this.loadTicket(this.ticketList['all open'][0])
        }
        if (this.ticketList['all closed'].length) {
          this.loadTicket(this.ticketList['all closed'][0])
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    cancelChanges () {
      if (this.action) { // in case come from different parent page, go there
        this.$router.go(-1)
      } else {
        this.lAction = 'view'
      }
    },
    saveChanges () {
      this.ticket.severity = this.ticket.is_critical ? 'Critical' : (this.ticket.severity === 'Major' ? 'Major' : 'Normal')

      if (this.lAction === 'create') {
        this.createTicket()
      } else if (this.lAction === 'update') {
        this.updateTicket()
      }
    },
    createTicket () {
      // validate and save Changes
      if (this.$refs.lForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/ticket/create', this.ticket)
        .then(response => {
          // refresh the ticket list
          this.loadTicketList()
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.beingSaved = false
        })
      }
    },
    updateTicket () {
      // update into db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/ticket/update', this.ticket)
      .then(response => {
        // update front end
        // refresh the list
        this.loadTicketList()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    deleteItem (curTicket) {
      if (!confirm('Sure, you want to delete the ticket "' + curTicket.ticket_title + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/ticket/delete', curTicket)
      .then(response => {
        // refresh the list
        this.loadTicketList()
        this.beingSaved = false
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    reopenTicket (curTicket) {
      if (!confirm('Sure, you want to reopen the ticket "' + curTicket.ticket_title + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/ticket/reopen', curTicket)
      .then(response => {
        // refresh the list
        this.loadTicketList()
        this.beingSaved = false
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    loadTicket (curTicket) {
      var qry = {
        params: {
          ticket_no: curTicket.ticket_no
        }
      }
      this.axios.get(config.API_URL + '/getSmartilityTicketDetail/', qry)
      .then(response => {
        curTicket.details = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        curTicket.details = []
      })
    },
    cancelComment (curTicket) {
      curTicket.ready_for_comment = false
      this.$forceUpdate()
    },
    postComment (curTicket) {
      if (curTicket.comment.notes.trim().length === 0) {
        this.msg('Comment is empty', true)
      } else {
        // save the changes in db
        this.beingSaved = true
        this.axios.post(config.API_URL + '/ticket/comment', curTicket)
        .then(response => {
          // refresh comment list
          curTicket.comment.ticket_no = curTicket.ticket_no
          curTicket.comment.user_id = config.USER_ID
          curTicket.comment.updated_dt = new Date()
          curTicket.comment.updated_by_temp = 'Me'
          curTicket.comment.ticket_status = 'Commented'
          curTicket.details.push(curTicket.comment)
          curTicket.ready_for_comment = false
          curTicket.comment = null
          this.beingSaved = false
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.beingSaved = false
        })
      }
    },
    prepareComment (curTicket) {
      curTicket.ready_for_comment = true
      curTicket.comment = {
        notes: ''
      }
      this.$forceUpdate()
    },
    deleteNotes (curTicket, curDetail, idx) {
      if (!confirm('Sure, you want to delete the comment?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/ticket/delete-notes', curDetail)
      .then(response => {
        // deleting the comment from particular index
        curTicket.details.splice(idx, 1)
        this.beingSaved = false
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Support.vue?9f3babbc